import { render } from "./navbar.vue?vue&type=template&id=438039f5&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "./styles/navbar.scss?vue&type=style&index=0&id=438039f5&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438039f5"]])

export default __exports__